import { Slugs } from 'common/urls/Slugs';
import React from 'react';
import { Routes } from 'src/shared/Routes';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { useBackButtonState } from 'src/shef-global-state/backButtonState';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import { match, P } from 'ts-pattern';
import { Button, Container, Icon } from './styles/backButton';
import { BackButtonProps } from './types';

export const BackButton: React.FC<BackButtonProps> = (props) => {
  const { showOnMobile = false } = props;

  const { backPath, goBack } = useBackButtonState();
  const [cachedZipCode] = useCachedZipCode();

  const { finalBackPath, onClick } = match<
    {
      backPath?: string;
      zipCode?: string;
    },
    { finalBackPath?: string; onClick?: () => void }
  >({
    backPath,
    zipCode: cachedZipCode ?? undefined,
  })
    .with({ backPath: P.string }, () => ({ onClick: goBack }))
    .with({ zipCode: P.string }, ({ zipCode }) => ({
      finalBackPath: getSluggedPath(Routes.CONSUMER_EXPLORE, [{ slug: Slugs.ZIP_CODE, value: zipCode }]),
    }))
    .otherwise(() => ({ finalBackPath: Routes.CONSUMER_LANDING }));

  return (
    <Container showOnMobile={showOnMobile}>
      <Button to={finalBackPath} onClick={onClick}>
        <Icon />
      </Button>
    </Container>
  );
};
